/* Adapter: Phase 1 backend's grouped part_numbers dict -> flat list shape
 * required by <PartNumbersList />.
 *
 * Backend shape:
 *   { FG: [{value, description}], SUPPLIER: [...], COMPONENT: [...],
 *     INVENTORY: [...], other: [{value, type, description}] }
 *
 * <PartNumbersList /> shape (flat):
 *   [{ id, part_number, part_number_type, part_description }, ...]
 *
 * The "other" bucket carries its original part_number_type on each entry's
 * `type` field; promote that to part_number_type. For the four canonical
 * groups, the dict key IS the part_number_type.
 *
 * Used by the Disposition detail pane in 2c. Defined in 2b so 2c is
 * pure assembly.
 */

export function flattenPartNumbers(grouped) {
  if (!grouped) return [];
  const out = [];
  for (const [key, arr] of Object.entries(grouped)) {
    if (!Array.isArray(arr)) continue;
    arr.forEach((pn, i) => {
      out.push({
        id: `${key}-${i}`,
        part_number: pn.value,
        part_number_type: key === 'other' ? (pn.type || 'OTHER') : key,
        part_description: pn.description || '',
      });
    });
  }
  return out;
}
